import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaCaretSquareRight } from "react-icons/fa";


const Details = () => {
    const { id } = useParams();
    const [data, setData] = useState({})

    useEffect(() => {
        fetch('/projects.json')
            .then(res => res.json())
            .then(data => {
                const findData = data.find(a => a.id == id)
                setData(findData)
                console.log(findData)

            })
    }, [id])
    return (
        <div>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mx-auto my-8'>
                <div class="carousel w-96 mx-auto h-[450px] bg-gray-900">
                    <div id="slide1" class="carousel-item relative w-full">
                        <img src={data.image1} class="mx-auto" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide4" class="btn btn-circle">❮</a>
                            <a href="#slide2" class="btn btn-circle">❯</a>
                        </div>
                    </div>
                    <div id="slide2" class="carousel-item relative w-full">
                        <img src={data.image2} class="mx-auto" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide1" class="btn btn-circle">❮</a>
                            <a href="#slide3" class="btn btn-circle">❯</a>
                        </div>
                    </div>
                    <div id="slide3" class="carousel-item relative w-full">
                        <img src={data.image3} class=" mx-auto" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide1" class="btn btn-circle">❮</a>
                            <a href="#slide3" class="btn btn-circle">❯</a>
                        </div>
                    </div>
                </div>
                <div class="w-[500px] py-4">
                    <div class="">
                        <h2 class="card-title font-bold text-xl uppercase font-serif my-3">Project Name : {data.subtitle}</h2>
                        <p className=' font-serif'><b>Project Description :</b> {data.description}</p>

                        <div class="rounded-lg my-5">
                            <ol class="divide-y items-center">
                                <li class="flex">
                                    <div className=' m-3'><FaCaretSquareRight /></div>
                                    <div>{data.points1}</div>
                                </li>
                                <li class="flex">
                                    <div className=' m-3'><FaCaretSquareRight /></div>
                                    <div>{data.points2}</div>
                                </li>
                                <li class="flex">
                                    <div className=' m-3'><FaCaretSquareRight /></div>
                                    <div>{data.points3}</div>
                                </li>
                                <li class="flex">
                                    <div className=' m-3'><FaCaretSquareRight /></div>
                                    <div>{data.points5}</div>
                                </li>
                                <li class="flex">
                                    <div className=' m-3'><FaCaretSquareRight /></div>
                                    <div className=''>{data.points4}</div>
                                </li>

                            </ol>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
};

export default Details;